module.exports = __webpack_public_path__ + "static/media/benefits11.edba414c.webp";